import React from 'react';
import { alpha, ButtonBase, Typography } from '@mui/material';

export interface FloatingHintPillProps {
	children: React.ReactNode;
	onClick?: () => void;
	startIcon?: React.ReactNode;
}

/** Bottom-center pill over a full-screen surface; positioned against the nearest positioned ancestor. */
const FloatingHintPill = ({ children, onClick, startIcon }: FloatingHintPillProps) => (
	<ButtonBase
		disabled={!onClick}
		onClick={onClick}
		sx={(theme) => ({
			position: 'absolute',
			bottom: 32,
			left: '50%',
			transform: 'translateX(-50%)',
			width: 'max-content',
			maxWidth: 'calc(100% - 32px)',
			px: 2,
			py: 1,
			gap: 1,
			border: `1px solid ${onClick ? alpha(theme.palette.primary.main, 0.5) : 'transparent'}`,
			borderRadius: 999,
			textAlign: 'center',
			color: onClick ? theme.palette.primary.main : theme.palette.text.secondary,
			backgroundColor: alpha(theme.palette.background.default, 0.7),
			backdropFilter: 'blur(8px)',
			WebkitBackdropFilter: 'blur(8px)',
		})}
	>
		{startIcon}
		<Typography variant="body2">
			{children}
		</Typography>
	</ButtonBase>
);

export default FloatingHintPill;
